import { action, atom, withInit } from '@reatom/framework'

import {
  CurrencyModel,
  nativeNetworkCurrencyAtom,
} from '@root/entities/currency'

import type { WalletModel } from '@root/entities/wallet/atoms'

export const transferCurrencyReatom = (wallet: WalletModel) => {
  const currencyAtom = atom(CurrencyModel.Ether, 'currencyAtom').pipe(
    withInit((ctx) => {
      const assets = ctx.get(wallet.assets)
      const asset = assets.at(0)
      if (!asset) {
        return ctx.get(nativeNetworkCurrencyAtom)
      }
      return asset.currency
    }),
  )

  const setCurrencyAction = action((ctx, currency: CurrencyModel) => {
    currencyAtom(ctx, currency)
  }, 'setCurrencyAction')

  return {
    currencyAtom,
    setCurrencyAction,
  }
}

export type TransferCurrencyReatom = ReturnType<typeof transferCurrencyReatom>
